/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareRightIcon20Light = forwardRef('ArrowFigureASquareRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.5 9.5A.5.5 0 0 1 6 9h6.219l-2.54-2.116a.5.5 0 1 1 .641-.768l2.678 2.232a1.5 1.5 0 0 1 0 2.304l-2.678 2.232a.5.5 0 0 1-.64-.768L12.219 10H6a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5.5A3.5 3.5 0 0 1 5.5 2h8A3.5 3.5 0 0 1 17 5.5v8a3.5 3.5 0 0 1-3.5 3.5h-8A3.5 3.5 0 0 1 2 13.5v-8ZM5.5 3A2.5 2.5 0 0 0 3 5.5v8A2.5 2.5 0 0 0 5.5 16h8a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 13.5 3h-8Z" })));
});
